import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { TextSeparatorComponent } from '@lib/shared-ui/commons/text-separator/text-separator.component';

import { TASK_DATA } from '../../../core/contracts/task-data.contract';
import { Task, TaskType } from '../../../core/models/task.interface';

@Component({
  selector: 'app-orphaned-offering-task-summary',
  standalone: true,
  imports: [TextSeparatorComponent, TranslatePipe],
  template: `
    <div class="flex items-center gap-2 text-neutral-500">
      <p class="font-bold text-neutral-900">{{ task.data.partnerName }}</p>
      <shared-text-separator />
      <p>{{ task.data.integration }}</p>
      <shared-text-separator />
      <p>{{ 'task.message.orphanedOfferingsCount' | translate: { count: task.data.offerings.length } }}</p>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrphanedOfferingTaskSummaryComponent {
  protected readonly task = inject<Task<TaskType.OrphanedOffering>>(TASK_DATA);
}
